<template>
	<div style="overflow-x: hidden;background-color: white;position: absolute;left: 0;right: 0;top: 0" class="bg">
		<Navigator :select-index="2"/>
		<SliderBanner :data="slider"/>
		<Info :items="infos"/>
		<Ad :data="ad"/>
		<Contact />
		<Footer />
	</div>
</template>

<script>
	import Navigator from '../index/widgets/navigator.vue'
	import Contact from "../index/widgets/Contact.vue"
	import Footer from '../index/widgets/footer.vue'
	import SliderBanner from "../local/widgets/SliderBanner.vue"
	import Info from "../local/widgets/Info.vue"
	import Ad from "../local/widgets/Ad.vue"
	export default {
		components: {
			Navigator,
			SliderBanner,
			Contact,
			Footer,
			Ad,
			Info,
		},
		data() {
			return {
				slider: {
					image: require('@/assets/images/guide/phone.png'),
					title: '智莺导购',
					desc: "导购平台网罗了淘宝、京东、天猫、拼多多、唯品会、苏宁易购、网易考拉等各大上市公司和知名电商平台，进行高质量低消费的品牌合作，全面而系统的整合京东商城的优质好物，满足广大消费者的爱好需求，同时可以领取高额优惠券，更有京东超级百万补贴、0元购和超低折扣不定时发放，超大程度吸引消费者，提升下单率，消费更省钱"

				},
				ad: {
					image: require('@/assets/images/local/ad.png'),
					title: '智莺导购',
					desc: "导购平台网罗了淘宝、京东、天猫、拼多多、唯品会、苏宁易购、网易考拉等各大上市公司和知名电商平台"
				},
				infos: [{
						title: '淘宝专题',
						desc: '丰富精美的淘宝专题页面，长期以来是众多消费者的首选，具有淘宝天猫半价购、天猫一分购等超划算的专题栏目，推广优质商品下单成功还有高额佣金收入，使平台更有魅力，充分吸引消费。',
						imgUrl: require("@/assets/images/guide/1.png"),
					},
					{
						title: '京东专题',
						desc: '智莺联合京东商城进行高质量低消费的品牌合作，全面而系统的整合京东商城的优质好物，满足广大消费者的爱好需求，同时可以领取高额优惠券，更有京东超级百万补贴、0元购和超低折扣不定时发放，超大程度吸引消费者，提升下单率，消费更省钱。',
						imgUrl: require("@/assets/images/guide/2.png"),
					},
					{
						title: '拼多多专题',
						desc: '智莺联合拼多多商城进行高质量低消费的品牌合作，全面而系统的整拼多多的优质好物，满足广大消费者的爱好需求，挖掘大量隐藏优惠券，让用户消费购物更钱！提高消费者的平台体验感...',
						imgUrl: require("@/assets/images/guide/3.png"),
					},
					{
						title: '唯品会专题',
						desc: '更具魅力的唯品会购物专场，聚集百万优质好物，可实现领取优惠券下单，进入超级省钱模式，促进卖家商品消费，买家省钱消费，站长超高佣金收入三方价值现，高度体现平台价值。',
						imgUrl: require("@/assets/images/guide/4.png"),
					},

				]
			}
		}
	}
</script>

<style scoped lang="scss">
	@media (max-width: 767px) {
		.bg {
			background-size: auto 500px;
			background-repeat: no-repeat;
		}
	}

	@media (min-width: 767px) {
		.bg {
			background-size: 100% auto;
			background-repeat: no-repeat;
		}
	}

	@media (min-width: 992px) {
		.bg {
			background-size: 100% auto;
			background-repeat: no-repeat;
		}
	}

	.bg {
		background-image: url(../../assets/images/local/bg.png);
		// background-size: 100% 500px;

	}
</style>
